import logo from "../images/logo.jpg";

export default function Data(props) {
  const styles = { display: "block" };

  return (
      <div className="data">
        <div className="pic" style={styles}>
          <img src={logo} alt="" />
        </div>
        <div className="details">
          <div className="headtag">{props.name}</div>
          <p>{props.details}</p>
        </div>
      </div>
    );
}
